/**
 * When "hide other variant media" is enabled, swiping/dragging the product
 * media gallery to a different color's photo also selects that color's
 * swatch, so the shopper only has to pick a size afterward.
 */
(function () {
  function initSwatchSync(gallery) {
    var sectionId = gallery.id.replace("Media-Gallery-", "");
    var variantSelects = document.getElementById(
      "Variant-Selects-" + sectionId,
    );
    if (!variantSelects) return;

    var mapScript = variantSelects.querySelector(
      "script[data-media-swatch-map]",
    );
    if (!mapScript) return;

    var mediaSwatchMap;
    try {
      mediaSwatchMap = JSON.parse(mapScript.textContent);
    } catch (e) {
      return;
    }
    if (!mediaSwatchMap || !Object.keys(mediaSwatchMap).length) return;

    gallery.addEventListener("sliderChanged", function (event) {
      if (!event.detail || !event.detail.currentElement) return;

      var mediaId = event.detail.currentElement.dataset.mediaId;
      var optionValueId = mediaId && mediaSwatchMap[mediaId];
      if (!optionValueId) return;

      var input = variantSelects.querySelector(
        'input[data-option-value-id="' + optionValueId + '"]',
      );
      if (!input || input.checked) return;

      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  // Un-hiding the other variant photos so the gallery can be swiped through
  // means the slider's install() now has to measure real layout metrics
  // instead of a trivial single-photo case. Its one-shot IntersectionObserver
  // can fire before the section's stylesheet has finished loading, measure a
  // collapsed layout, and give up for good (it never retries on its own).
  // Give it one retry once everything has actually finished loading.
  function ensureSliderInstalled(gallery) {
    var slider = gallery.querySelector("product-media-slider");
    if (!slider || slider.classList.contains("slider--installed")) return;
    if (slider.querySelectorAll('[id^="Slide-"]').length <= 1) return;
    slider.reInstall();
  }

  document.addEventListener("DOMContentLoaded", function () {
    var galleries = document.querySelectorAll(
      "media-gallery[data-hide-variants]",
    );
    galleries.forEach(initSwatchSync);

    window.addEventListener("load", function () {
      galleries.forEach(ensureSliderInstalled);
    });
  });
})();
